import Hero from "@/components/Hero";
import About from "@/components/About";
import Now from "@/components/Now";
import LinksGrid from "@/components/LinksGrid";
import ThemeToggle from "@/components/ThemeToggle";
import Footer from "@/components/Footer";
import Ambient from "@/components/Ambient";
import CopyLink from "@/components/CopyLink";

/**
 * Home – One-page digital business card.
 * Order: Hero → About → Now (currently exploring) → Links → Footer.
 * Global ambient background + subtle grain overlay create cinematic depth.
 */
export default function Home() {
  return (
    <main
      data-testid="home-page"
      className="relative min-h-screen bg-[#030303] text-[#FAFAFA] transition-colors duration-500"
    >
      {/* Layered ambient background (glow orbs + vignette) */}
      <Ambient />

      {/* Fine grain texture overlay for tactile depth */}
      <div className="grain-overlay" aria-hidden="true" />

      {/* Persistent share-link button (top-right) */}
      <CopyLink />

      {/* Persistent theme toggle (bottom-left) */}
      <ThemeToggle />

      {/* Content sits above ambient/grain layers */}
      <div className="relative z-10">
        <Hero />
        <About />
        <Now />
        <LinksGrid />
        <Footer />
      </div>
    </main>
  );
}
